import React, { useState, useEffect } from 'react'
import { Row, Table, ButtonGroup } from 'rsuite'
import TooltipButton from '../../components/buttons/TooltipButton'
const { Column, HeaderCell, Cell } = Table

export default function AttachFilesView({
  schema,
  onPreview,
  onDownload,
  autoHeight = true,
  ...props
}) {
  const [filelist, setFilelist] = useState([])

  useEffect(() => {
    setFilelist(schema.value || schema.values || [])
  }, [schema])

  return (
    <Row style={{ marginBottom: '2em' }}>
      <Table
        className="proposal-grantee-attach-files-table"
        autoHeight={autoHeight}
        minHeight={300}
        wordWrap
        bordered
        data={filelist}
      >
        <Column width={90} align="center" fixed>
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>
        <Column minWidth={300} flexGrow={1}>
          <HeaderCell>ชื่อไฟล์</HeaderCell>
          <Cell dataKey="label" />
        </Column>

        {schema.attachDetail && (
          <Column minWidth={300} flexGrow={1}>
            <HeaderCell>{schema.attachDetail.label}</HeaderCell>
            <Cell dataKey="detail" />
          </Column>
        )}

        <Column width={150} align="center" fixed="right">
          <HeaderCell className="proposal-grantee-attach-files-action-header"></HeaderCell>
          <Cell className="proposal-grantee-attach-files-action-cell">
            {(rowData) => {
              return (
                <ButtonGroup>
                  <TooltipButton
                    icon="eye"
                    tooltip={`แสดง`}
                    onClick={(e) => onPreview(rowData)}
                  ></TooltipButton>
                  <TooltipButton
                    icon="download"
                    tooltip={`ดาวน์โหลด`}
                    onClick={(e) => onDownload(rowData)}
                  ></TooltipButton>
                </ButtonGroup>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </Row>
  )
}
